import React from 'react';
import { Typography } from '@material-ui/core';
import { isNil, equals } from 'ramda';
import { useTranslation } from 'react-i18next';
import MessagePresenter from 'presenters/MessagePresenter';
import useStyles from './useStyles';

const LastMessage = props => {
  const { latestMessage, loanOfficerName, loanOfficerId } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  if (isNil(latestMessage)) {
    return null;
  }

  const lastMessageText = MessagePresenter.text(latestMessage);
  const lastMessageSenderId = MessagePresenter.senderId(latestMessage);
  const lastMessageSender = equals(lastMessageSenderId, loanOfficerId)
    ? loanOfficerName
    : t('components.LoanOfficerCard.buyerSender');

  return (
    <Typography color="textSecondary" variant="subtitle1" className={classes.message}>
      <b className={classes.bold}>{`${lastMessageSender}: `}</b>
      {lastMessageText}
    </Typography>
  );
};

export default LastMessage;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerCard/components/LastMessage/LastMessage.js